import noUiSlider from 'nouislider';

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#filters')
  if (!form) return

  const applyButton = document.querySelector('.search-sidebar__footer-apply')
  const clearButton = document.querySelector('.search-sidebar__footer-clear')
  const isMobile = () => window.innerWidth < 800

  const sliderEl = document.getElementById('price-slider')
  const hiddenMin = document.getElementById('price-min')
  const hiddenMax = document.getElementById('price-max')
  const displayMin = document.getElementById('range-display-min')
  const displayMax = document.getElementById('range-display-max')

  const defaultMin = 0
  const defaultMax = hiddenMax ? parseInt(hiddenMax.defaultValue || '100') : 100

  function updateFilterCount() {
    const checked = form.querySelectorAll('input[type="checkbox"]:checked').length

    const minVal = parseInt(hiddenMin?.value || '0', 10)
    const maxVal = parseInt(hiddenMax?.value || '0', 10)

    const priceSelected = minVal !== defaultMin || maxVal !== defaultMax

    const totalFilters = checked + (priceSelected ? 1 : 0)
    applyButton.innerHTML = `Apply Filters (${totalFilters})`
  }

  function applyFilters() {
    const url = buildURLFromFilters()
    window.location.href = url
  }

  function buildURLFromFilters() {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)

    const searchInput = form.querySelector('input[name="q"]')
    const query = searchInput ? searchInput.value : ''

    Array.from(params.keys()).forEach((key) => {
      if (key.startsWith('filter.')) params.delete(key)
    })

    form.querySelectorAll('input[type="checkbox"]:checked').forEach((checkedInput) => {
      params.append(checkedInput.name, checkedInput.value)
    })

    const priceMinInput = form.querySelector('input[name="filter.v.price.gte"]')
    const priceMaxInput = form.querySelector('input[name="filter.v.price.lte"]')
    if (priceMinInput && priceMinInput.value !== '') {
      params.set('filter.v.price.gte', priceMinInput.value)
    }
    if (priceMaxInput && priceMaxInput.value !== '') {
      params.set('filter.v.price.lte', priceMaxInput.value)
    }

    if (query) params.set('q', query)

    const prefixInput = url.searchParams.get('options[prefix]')
    if (prefixInput) {
      params.set('options[prefix]', prefixInput)
    }

    return `${window.location.pathname}?${params.toString()}`
  }

  // Input changes trigger filter update
  form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
    input.addEventListener('change', () => {
      updateFilterCount()
      if (!isMobile()) {
        applyFilters()
      }
    })
  })

  // Apply button
  applyButton.addEventListener('click', function () {
    applyFilters()
  })

  // Clear button
  clearButton.addEventListener('click', function () {
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.checked = false
    })

    if (sliderEl && sliderEl.noUiSlider) {
      sliderEl.noUiSlider.set([defaultMin, defaultMax])
    }

    updateFilterCount()

    if (!isMobile()) {
      applyFilters()
    }
  })

  // Init noUiSlider
  if (sliderEl && hiddenMin && hiddenMax && displayMin && displayMax) {
    const max = parseInt(sliderEl.dataset.max || hiddenMax.defaultValue || '100', 10)
    const startMin = parseInt(hiddenMin.value || defaultMin, 10)
    const startMax = parseInt(hiddenMax.value || max, 10)

    noUiSlider.create(sliderEl, {
      start: [startMin, startMax],
      connect: true,
      range: {
        min: 0,
        max: 300
      },
      step: 1,
      tooltips: false
    })

    sliderEl.noUiSlider.on('update', (values) => {
      const [valMin, valMax] = values.map(v => Math.round(v))
      displayMin.textContent = valMin
      displayMax.textContent = valMax
      hiddenMin.value = valMin
      hiddenMax.value = valMax
      updateFilterCount()
    })

    // Trigger apply only on desktop when user releases the handle
    sliderEl.noUiSlider.on('change', () => {
      if (!isMobile()) {
        applyFilters()
      }
    })
  }

  updateFilterCount()
})

document.addEventListener('DOMContentLoaded', function () {
  const sortSelect = document.querySelector('#sort_by')
  if (!sortSelect) return

  sortSelect.addEventListener('change', function () {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)

    params.set('sort_by', this.value)
    window.location.href = `${window.location.pathname}?${params.toString()}`
  })
})

document.addEventListener('DOMContentLoaded', function () {
  const filtersToggle = document.querySelector('.search-info__filters')
  const filters = document.querySelector('.search-sidebar')
  const filtersClose = document.querySelector('.search-sidebar__close')

  filtersToggle.addEventListener('click', function (e) {
    e.preventDefault()
    filters.classList.toggle('search-sidebar--active')
  })

  filtersClose.addEventListener('click', function (e) {
    e.preventDefault()
    filters.classList.remove('search-sidebar--active')
  })
})

document.addEventListener('DOMContentLoaded', function () {
  const dropdowns = document.querySelectorAll('.search-dropdown')

  dropdowns.forEach((dropdown) => {
    const header = dropdown.querySelector('.search-dropdown__header')
    const body = dropdown.querySelector('.search-dropdown__body')

    dropdown.classList.add('search-dropdown--active')
    body.style.maxHeight = body.scrollHeight + 'px'

    header.addEventListener('click', function () {
      const isActive = dropdown.classList.toggle('search-dropdown--active')

      body.style.maxHeight = isActive ? body.scrollHeight + 'px' : '0px'
    })
  })
})
